/**
 * What the PMS call dialog says about one call, from its rows (`/call/<id>` brackets).
 *
 * A dry run never reaches the PMS (pms-adapter `flush.py`): every row is `dry_run`, no HTTP code, and the back
 * returns `{}` as its response. It reads as a simulation — the Activity's own "simulated" chip, no origin wording
 * ("pushed by hand" would claim a send) and never a red note; an empty `{}` is truthy and used to paint one.
 */
const ORIGIN_LABEL = {
	run_now: 'pushed by hand',
	quarantine: 'approved from quarantine',
	override: 'pushed by override',
}

const isEmpty = (v) => v == null || v === '' || (typeof v === 'object' && Object.keys(v).length === 0)

const errorTextOf = (first) => {
	if (!first || first.status !== 'error' || isEmpty(first.raw_response)) return null
	const r = first.raw_response
	if (typeof r !== 'object') return String(r)
	return r.message || r._text || JSON.stringify(r)
}

export function callView(rows) {
	const first = rows?.[0]
	const simulated = !!first && rows.every(r => r.status === 'dry_run')
	if (simulated) {
		return { simulated, title: 'Simulated call — nothing was sent to the PMS',
		         originLabel: null, statusChip: 'dry_run', statusText: null, errorText: null }
	}
	return {
		simulated,
		title: 'One call to the PMS',
		originLabel: first ? (ORIGIN_LABEL[first.origin] || 'scheduled pass') : null,
		statusChip: null,
		statusText: first ? (first.status === 'ok' ? `HTTP ${first.response_code}` : first.status) : null,
		errorText: errorTextOf(first),
	}
}
